module.exports = __webpack_public_path__ + "static/media/flag-sprite.07119da2.svg";